import { toAbsoluteUrl } from "../../helpers";

type Props = {
  isChecked?: boolean;
  onChange: any;
};

const PayWithApple: React.FC<Props> = ({
  isChecked,
  onChange: handleModeChange,
}) => {
  return (
    <>
      <div className="choose_payment_method_colm card mb-2">
        <div className="card_viza card_viza2">
          <label>
            <span>
              <input
                id="pay_with_apple"
                type="radio"
                name="payment_mode"
                checked={isChecked}
                onChange={handleModeChange}
              />{" "}
              Apple Pay{" "}
            </span>
            <img
              src={toAbsoluteUrl("images/pay-icon.svg")}
              className="visa_img"
              alt=""
            />
          </label>
        </div>
      </div>
    </>
  );
};

export default PayWithApple;
